import { Link as RLink } from 'react-router-dom';
import { Box, styled } from '@mui/material';

import { colors, devices, zIndex } from '../../styles';

export const FooterWrapper = styled(Box)`
  background-color: ${colors.mainDark};
  padding: 60px;
  position: relative;
  z-index: 2;
`;

export const FooterNavigation = styled('nav')`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: ${zIndex.layer};

  .logo-wrapper img {
    width: 200px;
  }
`;

export const LogoAndNav = styled(Box)`
  display: flex;
  margin-bottom: 0;
  flex-direction: column;
  align-items: center;

  @media (${devices.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    margin-bottom: 36px;
  }
`;

export const LinksWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
  max-width: 300px;

  @media (${devices.sm}) {
    max-width: 100%;
  }

  @media (${devices.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 500px;

    margin-bottom: 36px;
  }
`;

export const Link = styled(RLink)`
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  color: ${colors.mainGray};
  text-decoration: none;
  margin-top: 16px;

  &:hover {
    color: ${colors.white};
  }
`;

export const LinkTitle = styled('h4')`
  margin: 0;

  & > a {
    color: ${colors.white};
    font-size: 18px;
    line-height: 22px;
  }
`;

export const LinksSection = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  @media (${devices.md}) {
    margin-bottom: 0;
  }
`;

export const LinksSectionCompany = styled(LinksSection)`
  display: block;
  min-width: 135px;

  @media (${devices.sm}) {
    min-width: auto;
  }

  h4 {
    margin-bottom: 0px;

    @media (${devices.md}) {
      margin-bottom: 16px;
    }

    a {
      margin: 0;
    }
  }

  a {
    display: block;
  }
`;

export const LinksSectionPlatform = styled(LinksSection)`
  display: block;
`;

export const LinksSectionIndustries = styled(LinksSection)`
  display: block;
`;

export const IndustriesList = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const PrivacyLink = styled('span')`
  text-decoration: none;
  cursor: pointer;
  color: inherit;
`;

export const SubText = styled('div')`
  display: flex;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 15px;

  a {
    cursor: pointer;
    color: inherit;
  }
`;

export const SocialMediaBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    display: block;
  }
`;

export const CopyrightInfo = styled(Box)`
  display: flex;
  color: ${colors.mainGray};
  flex-direction: column;
  align-items: center;

  width: 100%;

  @media (${devices.md}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const InfoLink = styled('a')({
  fontSize: '12px',
  lineHeight: '100%',
  textAlign: 'center',
  textDecoration: 'underline',
  color: '#FFFFFFCC',
});
